module.exports = __webpack_public_path__ + "img/inge-v9-char-4.c9268bf7.png";